/** The ranges the Insights page offers, other than a custom one. */
export const DATE_RANGE_PRESETS = [
    'today',
    'yesterday',
    'weekToDate',
    'last7Days',
    'lastWeek',
    'monthToDate',
    'lastMonth',
    'yearToDate',
    'lastYear',
];
export const DATE_RANGE_PRESET_LABELS = {
    today: 'Today',
    yesterday: 'Yesterday',
    weekToDate: 'Week to Date',
    last7Days: 'Last 7 Days',
    lastWeek: 'Last Week',
    monthToDate: 'Month to Date',
    lastMonth: 'Last Month',
    yearToDate: 'Year to Date',
    lastYear: 'Last Year',
};
export const isDateRangePreset = (value) => DATE_RANGE_PRESETS.includes(value);
/** A local date as `YYYY-MM-DD` - never `toISOString()`, which is the UTC date. */
export const toLocalDateString = (date) => {
    const pad = (value) => String(value).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};
// Local midnight `days` days from `date`. The Date constructor rolls over month and year ends,
// and building from parts keeps clear of DST shifts that adding milliseconds would hit.
const addDays = (date, days) => new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);
const range = (start, end) => ({
    startDate: toLocalDateString(start),
    endDate: toLocalDateString(end),
});
/**
 * The days a preset covers, as of `now` in the browser's time zone. Weeks start on Sunday.
 * Ranges "to date" end today, so they include today's activity so far.
 */
export const getPresetRange = (preset, now = new Date()) => {
    const today = addDays(now, 0);
    const year = today.getFullYear();
    const month = today.getMonth();
    const startOfWeek = addDays(today, -today.getDay());
    switch (preset) {
        case 'today':
            return range(today, today);
        case 'yesterday':
            return range(addDays(today, -1), addDays(today, -1));
        case 'weekToDate':
            return range(startOfWeek, today);
        case 'last7Days':
            return range(addDays(today, -6), today);
        case 'lastWeek':
            return range(addDays(startOfWeek, -7), addDays(startOfWeek, -1));
        case 'monthToDate':
            return range(new Date(year, month, 1), today);
        case 'lastMonth':
            // Day 0 of this month is the last day of the previous one
            return range(new Date(year, month - 1, 1), new Date(year, month, 0));
        case 'yearToDate':
            return range(new Date(year, 0, 1), today);
        case 'lastYear':
            return range(new Date(year - 1, 0, 1), new Date(year - 1, 11, 31));
    }
};
